import React from "react";

const Reports = () => {
  return <>Reports Page</>;
};
export default Reports;
